import { render, staticRenderFns } from "./PrevilageTable.vue?vue&type=template&id=676472d8&scoped=true"
import script from "./PrevilageTable.vue?vue&type=script&lang=js"
export * from "./PrevilageTable.vue?vue&type=script&lang=js"
import style0 from "./PrevilageTable.vue?vue&type=style&index=0&id=676472d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676472d8",
  null
  
)

export default component.exports